import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Setup from './Setup';

function RootSetup() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.title = t('Meta.title');
    document.documentElement.lang = i18n.language;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute('content', t('Meta.description'));
  }, [t, i18n]);

  return <Setup />;
}

export default RootSetup;
